import Http from "@/commons/Http";

export default {
  async iniciar(indicadores, registros) {
    return Http.post('/api/cnm-lote', { indicadores, registros });
  },

  async listar() {
    return Http.get('/api/cnm-lote');
  },

  async detalhar(id) {
    return Http.get(`/api/cnm-lote/${id}`);
  },

  async exportarXls() {
    return Http.get('/api/cnm-lote/exportar-xls', { responseType: 'blob' });
  },

  classeStatus(status) {
    if (status === 'SUCESSO') return 'badge badge-success';
    if (status === 'PULADO') return 'badge badge-warning';
    if (status === 'ERRO') return 'badge badge-danger';
    return 'badge badge-secondary';
  },
};
